export default {"src":"/_next/static/media/white-north-arrow.d72f96b0.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};